import earchiveList from "dummydata/earchiveList";
import { EARCHIVE_TOTAL } from "redux/actionTypes/actionTypes";
import { DELETE_EARCHIVE } from "redux/actionTypes/actionTypes";
import { ADD_EARCHIVE } from "redux/actionTypes/actionTypes";

const initialState = {
  earchiveList: [],
  earchiveTotal: 0,
};

const earchiveReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_EARCHIVE:
      return {
        ...state,
        earchiveList: action.payload,
      };
      break;
    case DELETE_EARCHIVE:
      return {
        ...state,
        earchiveList: state.earchiveList.filter(
          (item) => !action.payload.includes(item.key)
        ),
      };
      break;
    case EARCHIVE_TOTAL:
      return {
        ...state,
        earchiveTotal: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};
export default earchiveReducer;
